import { useContext } from 'react'
import { enqueueSnackbar } from 'notistack'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'

import { AppContext } from '/providers/app-context'
import { deletePasses } from '/providers/passes-api'
import ActionErrorDialog from '/components/action-error-dialog'
import useActionErrorDialog from '/components/use-action-error-dialog'

const DeleteSelectedPassesDialog = ({ open, setOpen, selection, onDeleted }) => {
  const { apiSource, apiKey, processing, setProcessing } = useContext(AppContext)
  const { actionError, errorDialogOpen, setErrorDialogOpen, showActionError } = useActionErrorDialog()
  const passes = selection.type === 'allMatching' ? selection.loadedPasses : selection.passes
  const passIds = passes.map(pass => pass.pass_id)

  const close = () => setOpen(false)

  const remove = async () => {
    setProcessing(true)

    const result = await deletePasses({
      apiSource,
      apiKey,
      apiMode: selection.mode,
      passes: passIds
    })

    setProcessing(false)

    if (result.ok) {
      close()
      enqueueSnackbar({ message: `${result.num_passes_deleted.toLocaleString()} pass${result.num_passes_deleted === 1 ? '' : 'es'} deleted`, variant: 'success' })
      onDeleted(passIds)
    } else {
      showActionError(result.error, 'Deletion failed')
    }
  }

  return (
    <>
      <Dialog open={open} onClose={close} aria-labelledby="delete-selected-passes-title">
        <DialogTitle id="delete-selected-passes-title">Delete selected passes?</DialogTitle>
        <DialogContent>
          <p>This will permanently delete {passIds.length.toLocaleString()} selected pass{passIds.length === 1 ? '' : 'es'}.</p>
          {selection.type === 'allMatching' && <p>Only the loaded and checked passes will be deleted.</p>}
        </DialogContent>
        <DialogActions>
          <div className="flex flex-row justify-between w-full p-5">
            <Button variant="outlined" onClick={close} disabled={processing}>Cancel</Button>
            <Button variant="contained" color="error" onClick={remove} disabled={processing || passIds.length === 0} autoFocus>
              <DeleteOutlineIcon className="mr-5" />Delete passes
            </Button>
          </div>
        </DialogActions>
      </Dialog>
      <ActionErrorDialog title="Deletion failed" open={errorDialogOpen} setOpen={setErrorDialogOpen} error={actionError} />
    </>
  )
}

export default DeleteSelectedPassesDialog
